import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import { useState, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import DeskUseDataFunc from "@/pcomponents/common/content/edu/desk/func/desku_func";
import { useSelector, useDispatch } from 'react-redux';

function ViewDeskPopup(props: any) {
  const myProps = {
    closePopup: () => { },
    room_info: null,
    desk_info: null,
    desku_info: null,
    now_ymdhis: "",
    now_lecture_data: null,
    callBackData: () => { },
    callback_update: (inData:any) => { },
    callback_delete: (inData:any) => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  let comp_sort_detail = user.comp_sort_detail;

  let select_subject_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'study_title', 'key': 'a_subject_sort' });
  const [add_time_data, set_add_time_data] = useState({
    add_minute: 0
  });
  const [desku_info, set_desku_info] = useState({ ...myProps.desku_info });
  let desk_use_time_data = DeskUseDataFunc.get_desk_use_time_data({
    now_ymdhis: myProps.now_ymdhis,
    desku_info: desku_info
  });

  useEffect(() => {

  }, []);

  const on_change_input = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    let change_desku_info: any = { ...desku_info };
    change_desku_info[name] = value;
    set_desku_info(change_desku_info);
  };

  const on_change_add_time = (inData: any) => {
    let name = inData.name;
    let value = inData.value;
    let change_add_time_data: any = { ...add_time_data };
    change_add_time_data[name] = value;
    set_add_time_data(change_add_time_data);
  };

  const onChangeTimeRowInput = (key: string, val: string) => {
    let time_col_arr = [
      "a_start_h", "a_start_m",
      "a_end_h", "a_end_m"
    ];
    let change_desku_info = { ...desku_info };
    if (strFunc.str_in_array(key, time_col_arr) != -1) {
      val = strFunc.comma(val);
      val = val.substring(0, 2);
      if (key == "a_start_h" || key == "a_end_h") {
        if (parseInt(val) >= 24) {
          val = "23";
        }
      } else {
        if (parseInt(val) >= 60) {
          val = "59";
        }
      }
      if (parseInt(val) < 0) {
        val = "0";
      }
    }
    change_desku_info[key] = val;
    if (strFunc.str_in_array(key, time_col_arr) != -1) {
      let tmp_time_data = DeskUseDataFunc.get_desk_use_time_data({
        now_ymdhis: myProps.now_ymdhis,
        desku_info: change_desku_info
      });
      change_desku_info["a_target_time_sec"] = tmp_time_data.per_target_num;
    }

    set_desku_info({
      ...desku_info,
      [key]: val
    });
  };

  const get_use_time_str = () => {
    if (myProps.desku_info == null) {
      return "";
    }

    let use_time_str = (
      <div>
        <span className="mx-2">
          <input type="text" className="text-center" name="a_start_h" value={strFunc.str_pad({ "str": desku_info.a_start_h, "pad_length": 2 })} onClick={(e:any)=>{e.target.select();}}
            onChange={(e: any) => { onChangeTimeRowInput(e.target.name, e.target.value); }} style={{ width: 30 }} />:
          <input type="text" className="text-center" name="a_start_m" value={strFunc.str_pad({ "str": desku_info.a_start_m, "pad_length": 2 })} onClick={(e:any)=>{e.target.select();}}
            onChange={(e: any) => { onChangeTimeRowInput(e.target.name, e.target.value); }} style={{ width: 30 }} />
        </span>
        ~
        <span className="mx-2">
          <input type="text" className="text-center" name="a_end_h" value={strFunc.str_pad({ "str": desku_info.a_end_h, "pad_length": 2 })} onClick={(e:any)=>{e.target.select();}}
            onChange={(e: any) => { onChangeTimeRowInput(e.target.name, e.target.value); }} style={{ width: 30 }} />:
          <input type="text" className="text-center" name="a_end_m" value={strFunc.str_pad({ "str": desku_info.a_end_m, "pad_length": 2 })} onClick={(e:any)=>{e.target.select();}}
            onChange={(e: any) => { onChangeTimeRowInput(e.target.name, e.target.value); }} style={{ width: 30 }} />
        </span>
        <span className="ml-1" style={{ color: "#00f", fontWeight: "bold" }}>
          ({
            desk_use_time_data.is_target_time ?
              desk_use_time_data.remain_minute_num :
              desk_use_time_data.elapse_minute_num
          }분/
          {desk_use_time_data.per_target_num>0?desk_use_time_data.per_target_num / 60 : 0}분
          )
        </span>
        <button className="btn btn-sky ml-1"
          onClick={() => { go_write_desk_use_by_ajax(); }}>변경저장</button>
      </div>
    );
    return use_time_str;
  };

  const get_add_time_str = () => {
    if (myProps.desku_info == null) {
      return "";
    }
    let desku_info = myProps.desku_info;
    let start_date_str = desku_info["a_date"] + " " + strFunc.HourMinuteToTime(desku_info["a_start_h"], desku_info["a_start_m"]) + ":00";
    let start_date_json = DateFunc.get_date_json(new Date(start_date_str));
    let end_date_str = desku_info["a_date"] + " " + strFunc.HourMinuteToTime(desku_info["a_end_h"], desku_info["a_end_m"]) + ":00";
    if (!strFunc.is_empty(desku_info["a_end_date"])) {
      end_date_str = desku_info["a_end_date"] + " " + strFunc.HourMinuteToTime(desku_info["a_end_h"], desku_info["a_end_m"]) + ":00";
    }
    let end_date_json = DateFunc.get_date_json(new Date(end_date_str));

    let add_time_sec = add_time_data["add_minute"] * 60;
    let start_sec = start_date_json.date_obj.getTime() / 1000;
    let end_sec = end_date_json.date_obj.getTime() / 1000;

    let start_time_hi = strFunc.HourMinuteToTime(desku_info["a_start_h"], desku_info["a_start_m"]);
    let change_end_time_hi = strFunc.HourMinuteToTime(desku_info["a_end_h"], desku_info["a_end_m"]);

    let add_time_str = (
      <span>
        {start_time_hi}
        <span className="mx-2">~</span>
        {change_end_time_hi}
        <span className="ml-1" style={{ color: "#00f", fontWeight: "bold" }}>({add_time_data["add_minute"]}분)</span>
      </span>
    );
    return add_time_str;
  };

  const cancel_desk_use = () => {
    if (myProps.desku_info == null) {
      return "";
    }
    if (!confirm(myProps.desku_info.a_user_name + "님의 사용을 취소 하시겠습니까?")) {
      return false;
    }

    let del_row = {
      "a_ymd": myProps.desku_info["a_ymd"],
      "a_seq": myProps.desku_info["a_seq"],
    };
    let del_desku_form_json = {
      "data_arr": [del_row],
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/desku/delete', del_desku_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          myProps.callback_delete({
            desk_use_arr:[myProps.desku_info],
          });
          myProps.callBackData();
          myProps.closePopup();
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const go_add_desk_use_time = () => {
    if (add_time_data["add_minute"] == 0) {
      alert("시간 선택이 없습니다.");
      return false;
    }
    let add_time_sec = add_time_data["add_minute"] * 60;
    let desku_info = myProps.desku_info;
    let start_date_str = desku_info["a_date"] + " " + strFunc.HourMinuteToTime(desku_info["a_start_h"], desku_info["a_start_m"]) + ":00";
    let start_date_json = DateFunc.get_date_json(new Date(start_date_str));
    let end_date_str = desku_info["a_date"] + " " + strFunc.HourMinuteToTime(desku_info["a_end_h"], desku_info["a_end_m"]) + ":00";
    if (!strFunc.is_empty(desku_info["a_end_date"])) {
      end_date_str = desku_info["a_end_date"] + " " + strFunc.HourMinuteToTime(desku_info["a_end_h"], desku_info["a_end_m"]) + ":00";
    }
    let end_date_json = DateFunc.get_date_json(new Date(end_date_str));

    let start_sec = start_date_json.date_obj.getTime() / 1000;
    let end_sec = end_date_json.date_obj.getTime() / 1000;

    let start_time_sec = start_sec;
    let end_time_sec = end_sec;

    let change_end_time_sec = end_time_sec + add_time_sec;
    if (start_time_sec >= change_end_time_sec) {
      alert("시작시간보다 작을 수 없습니다.");
      return false;
    } else if (add_time_sec > 86400) {
      alert("추가시간은 하루를 넘을 수 없습니다.");
      return false;
    }

    // if (!confirm("적용 하시겠습니까?")) {
    //   return false;
    // }

    let target_time_sec = change_end_time_sec - start_time_sec;
    let change_date_obj = DateFunc.get_change_date(new Date(end_date_str), 'sec', add_time_sec);
    let change_end_date_json = DateFunc.get_date_json(change_date_obj);
    let change_end_date_str = DateFunc.get_date_format(change_date_obj, "Y-m-d");
    let change_use_data_row = {
      a_ymd: myProps.desku_info["a_ymd"],
      a_seq: myProps.desku_info["a_seq"],
      a_end_h: change_end_date_json.h,
      a_end_m: change_end_date_json.i,
      a_end_date: change_end_date_str,
      a_target_time_sec: target_time_sec,
    };
    let form_json_data = {
      "data_arr": [change_use_data_row],
      "is_update": "1"
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/desku/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          myProps.callback_update({
            desk_use_arr:response.data["data"],
          });
          myProps.callBackData();
          myProps.closePopup();
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const go_write_desk_use_by_ajax = () => {
    // if (!confirm("적용 하시겠습니까?")) {
    //   return false;
    // }

    let change_desku_info: any = { ...desku_info };

    let tmp_time_data = DeskUseDataFunc.get_desk_use_time_data({
      now_ymdhis: myProps.now_ymdhis,
      desku_info: change_desku_info
    });

    if(change_desku_info["a_is_target_time"]=="1"){
      // change_desku_info["a_is_finish"]="1";
    }else{
      //자동종료가 이나고 변경시간이 현시간보다 작으면 완료처리
      if(tmp_time_data.percent_num>=100){
        change_desku_info["a_is_finish"] = "1";
      }
    }
    let form_json_data: any = {
      "data_arr": [change_desku_info],
      "is_update": "1"
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/desku/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          myProps.callback_update({
            desk_use_arr:response.data["data"],
          });
          myProps.callBackData();
          myProps.closePopup();
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const go_finish_desk_use = () => {
    // if (!confirm("사용종료 하시겠습니까?")) {
    //   return false;
    // }
    let change_use_data_row: any = {
      a_ymd: myProps.desku_info["a_ymd"],
      a_seq: myProps.desku_info["a_seq"],
    };
    let tmp_end_hi = strFunc.HourMinuteToTime(myProps.desku_info["a_start_h"], myProps.desku_info["a_start_m"]);
    let tmp_start_date_json = DateFunc.get_date_json(new Date(myProps.desku_info["a_date"] + " " + tmp_end_hi + ":00"));
    let now_date_json = DateFunc.get_date_json(new Date(myProps["now_ymdhis"]));
    change_use_data_row["a_end_date"] = DateFunc.get_date_format(now_date_json.date_obj, "Y-m-d");
    change_use_data_row["a_end_h"] = now_date_json.h;
    change_use_data_row["a_end_m"] = now_date_json.i;
    let target_time_sec = now_date_json.date_obj.getTime() - tmp_start_date_json.date_obj.getTime();
    if (target_time_sec > 0) {
      target_time_sec = target_time_sec / 1000;
    } else {
      target_time_sec = 0;
    }
    change_use_data_row["a_target_time_sec"] = target_time_sec;
    change_use_data_row["a_is_finish"] = "1";
    let form_json_data = {
      "data_arr": [change_use_data_row],
      "is_update": "1"
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/desku/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          myProps.callback_update({
            desk_use_arr:response.data["data"],
          });
          myProps.callBackData();
          myProps.closePopup();
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  return (
    <div>
      <div className="view-table-div">
        <table>
          <colgroup>
            <col width="100px"></col>
            <col width="*"></col>
          </colgroup>
          <tbody>
            <tr>
              <th>강의실</th>
              <td>
                {myProps.room_info ? myProps.room_info.a_name : ""}
              </td>
            </tr>
            <tr>
              <th>책상</th>
              <td>
                {myProps.desk_info ? myProps.desk_info.a_name : ""}
              </td>
            </tr>
            <tr>
              <th>사용자</th>
              <td>
                {myProps.desku_info ? myProps.desku_info.a_user_name : ""}
              </td>
            </tr>
            <tr>
              <th>과목</th>
              <td>
                <input type="text" name="a_subject" value={desku_info.a_subject}
                  onChange={on_change_input} style={{ width: "80px" }} autoComplete='off' />
                <select className="border" name="a_subject" value={desku_info.a_subject}
                  onChange={on_change_input}>
                  <option value="">선택</option>
                  {select_subject_option_arr.map((item: any, idx: number) => {
                    return (
                      <option key={idx} value={item["value"]}>{item["text"]}</option>
                    );
                  }
                  )}
                </select>
                <button className="btn btn-sky ml-1"
                  onClick={() => { go_write_desk_use_by_ajax(); }}>변경저장</button>
              </td>
            </tr>
            <tr>
              <th>사용시간</th>
              <td>
                {myProps.desku_info ?
                  <span>
                    {get_use_time_str()}
                  </span>
                  : ""}
              </td>
            </tr>
            <tr>
              <th>시간추가</th>
              <td>
                <div className="text-left">
                  <div>
                    {get_add_time_str()}
                    <button className="btn btn-darkgreen ml-2" onClick={() => { go_add_desk_use_time(); }}>시간추가 적용</button>
                  </div>
                  <div className="mt-1">
                    <button className="btn btn-yellowish3"
                      onClick={() => {
                        on_change_add_time({ name: "add_minute", value: add_time_data["add_minute"] + 1 });
                      }}>+1분</button>
                    <button className="btn btn-yellowish3 ml-1"
                      onClick={() => {
                        on_change_add_time({ name: "add_minute", value: add_time_data["add_minute"] + 10 });
                      }}>+10분</button>
                    <button className="btn btn-dark ml-1"
                      onClick={() => {
                        on_change_add_time({ name: "add_minute", value: add_time_data["add_minute"] - 1 });
                      }}>-1분</button>
                    <button className="btn btn-dark ml-1"
                      onClick={() => {
                        on_change_add_time({ name: "add_minute", value: add_time_data["add_minute"] - 10 });
                      }}>-10분</button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn-box-center mt-1">
        {myProps.desku_info != null &&
          <span>
            {comp_sort_detail != "sntbr"&&
              <button className="btn-m btn-line-gray" onClick={() => { go_finish_desk_use(); }}>사용종료</button>
            }
            <button className="btn-m btn-red ml-1" onClick={() => { cancel_desk_use(); }}>사용취소</button>
          </span>
        }
        <button className="btn-m btn-line-gray" onClick={() => { myProps.closePopup(); }}>닫기</button>
      </div>
    </div>
  );
}

export default ViewDeskPopup;